import { format, parse } from "date-fns";
import Papa from "papaparse";
import { ErrorMessages } from "./errorCodes.mjs";
import { HeadCountFileFormat } from "./types.mjs";
/**
 * Date normalisation for uploaded head-count files.
 *
 * Deliberately separate from `validationService.mts`: that module pulls in xlsx
 * and the decorated class-validator classes, whose registration side effects
 * cannot be tree-shaken. `data-transformations.mts` needs only this, so keeping
 * it here stops every OPP parcel inheriting those packages.
 */
const DATE_FORMATS = [
    "yyyy-MM-dd",
    "yyyy/MM/dd",
    "dd-MM-yyyy",
    "dd/MM/yyyy",
    "yyyy年MM月dd日",
    "dd.MM.yyyy",
];
export function parseDate(dateString) {
    for (const fmt of DATE_FORMATS) {
        try {
            const parsedDate = parse(dateString, fmt, new Date());
            if (!isNaN(parsedDate.getTime())) {
                return format(parsedDate, "yyyy-MM-dd");
            }
        }
        catch (error) {
            // Try the next format
        }
    }
    throw { code: ErrorMessages.fileUploadInvalidDateFormat };
}
export function normalizeFileDates(buffer, fileFormat) {
    // Invision files have fixed date format. They do not need to be normalized since they are generated by system
    if (fileFormat === HeadCountFileFormat.INVISION) {
        return buffer;
    }
    const parsedBuffer = Papa.parse(buffer);
    const parsedData = parsedBuffer.data;
    const delimiter = parsedBuffer.meta.delimiter;
    const dateIndex = fileFormat === HeadCountFileFormat.CFF ? 1 : 0;
    const formattedData = [parsedData.shift()];
    for (let i = 0; i < parsedData.length; i++) {
        const row = parsedData[i];
        const isEmptyRow = row.every((cell) => cell == null || String(cell).trim() === "");
        if (isEmptyRow) {
            continue;
        }
        const rawDate = row[dateIndex];
        if (rawDate != null && String(rawDate).trim() !== "") {
            row[dateIndex] = parseDate(String(rawDate).trim());
        }
        formattedData.push(row);
    }
    // defaults to commas as delimiter, but we want semicolons to minimze code changes
    return Papa.unparse(formattedData, { delimiter, newline: "\n" });
}
//# sourceMappingURL=normalize-file-dates.mjs.map